import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiDateRange, UiUserSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import { toast } from "react-toastify";
import { Table } from 'antd';
import { getStorage, setStorage, updateFilterUrl, rupees } from "../../helper.js";
import { Dropdown, Popconfirm, Menu } from 'antd';
import { MdOutlineMoreVert } from "react-icons/md";
import { render } from "react-dom";
import { IoMdClose } from "react-icons/io";
import { set } from "date-fns";


export default function Jobs() {
  let navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [pagenum, setPage] = useState(1);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);
  const [initialLoad, setInitLoad] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);


  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: getStorage('perpage') ? [20, 50, 100, 500].includes(parseInt(getStorage('perpage'))) ? parseInt(getStorage('perpage')) : 20 : 20,
      showSizeChanger: true,
      pageSizeOptions: [20, 50, 100, 500],
    },

  });


  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });






  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])
    setSelectedRows([])
    setPage(1)
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'jobs', 1), { replace: location.search ? true : false })


  };



  const handleDelete = (id) => {
    var tid = id.toString();

    setTableDisable(true)
    instance
      .delete("/jobs/" + tid)
      .then(function (response) {
        setTableDisable(false)
        if (response.status == 200) {
          queryClient.invalidateQueries(['jobs'])
          clearSelection()
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }
      })
  }




  const items = (e) => [
    {
      key: '1',
      label: <span>Edit</span>,
      onClick: () => addAccount(e.id),
    },
    {
      key: '2',
      label: (
        <Popconfirm
          title="Delete?"
          description="Are you sure to delete this?"
          onConfirm={() => handleDelete(e.id)}
          okText="Yes"
          cancelText="No"
        >
          <span>Delete</span>
        </Popconfirm>
      ),
    },


  ];

  const headers = [
    { label: "Date", key: "date" },
    { label: "Name", key: "name" },
    { label: "Mobile", key: "mobile" },
    { label: "City", key: "city" },
    { label: "Item", key: "item" },
    { label: "Problem", key: "problem" },
    { label: "Status", key: "status" },
    { label: "Estimate", key: "estimate" },
    { label: "Estimate Time", key: "estimate_time" },







  ];

  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/jobs" + filter
    );

    var dataa = data;
    return dataa;
  }

  const defaultValues = {
    search: null,
    status: '',
    date: 'All Time',
  };

  const clearFilter = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    reset(defaultValues)
    navigate(updateFilterUrl({}, 'jobs', 1), { replace: true })
  }


  useEffect(() => {

    const parsed = queryString.parse(location.search);

    if (location.search) {
      //setPage(parseInt(parsed.page))
    } else {
      setPage(1)
      setFilter(defaultValues)
    }



  }, [location]);

  const accountModal = useModal('job');

  const addAccount = (id) => {
    accountModal.show({ id: id }).then((res) => {
      queryClient.invalidateQueries(['jobs'])
    });
  }

  const viewjobmodal = useModal('view-job');

  const viewJob = (id) => {
    viewjobmodal.show({ id: id }).then((res) => {
      queryClient.invalidateQueries(['jobs'])
    });
  }

  useEffect(() => {


    const parsed = queryString.parse(location.search);

    if (parsed.page) {
      setPage(parseInt(parsed.page))
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          current: parseInt(parsed.page),
        },
      });
    } else {
      // setPage(1)
    }

    setFilter(parsed)




  }, []);


  const columns = [
    {
      title: 'ID',
      width: '40px',
      dataIndex: 'id',
      sorter: 'id',
      sortOrder: parsed.sort_by == 'id' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'id' && parsed.sort == 'desc' ? 'descend' : '',
    },
    {
      title: 'Date',
      width: '80px',
      dataIndex: 'date',
      sorter: 'date',
      sortOrder: parsed.sort_by == 'date' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'date' && parsed.sort == 'desc' ? 'descend' : '',
    },
    {
      title: 'Name',
      width: '160px',
      dataIndex: 'name',
      sorter: 'name',
      render: (text, row) => (<><div className="d-flex"><span className="text-truncate" title={row.name}><span className="text-primary h-pointer" onClick={() => viewJob(row.id)}>{row.name}</span></span></div>{row.url}</>),
      sortOrder: parsed.sort_by == 'name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'name' && parsed.sort == 'desc' ? 'descend' : '',
    },

    {
      title: 'Mobile',
      width: '100px',
      dataIndex: 'mobile',
    },
    {
      title: 'City',
      width: '70px',
      dataIndex: 'city',
    },
    {
      title: 'Item',
      width: '100px',
      dataIndex: 'item',
      render: (text, row) => (<><div className="d-flex"><span className="text-truncate" title={row.item}>{row.item}</span></div></>),
    },
    {
      title: 'Status',
      width: '100px',
      dataIndex: 'status',
      sorter: 'status',
      sortOrder: parsed.sort_by == 'status' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'status' && parsed.sort == 'desc' ? 'descend' : '',
      render: (text, row) => (<><div className="d-flex"><span className={`badge ${row.status}`}>{row.status}</span></div></>),

    },
    {
      title: 'Estimate',
      width: '70px',
      dataIndex: 'estimate',
    },
    {
      title: 'Estimated Time',
      width: '110px',
      dataIndex: 'estimate_time',
    },
    {
      title: 'Problem',
      width: '110px',
      dataIndex: 'problem',
    },



    {
      title: '',
      fixed: 'right',
      width: '40px',
      render: (text, row) => (
        <div className="tableaction1">
          <Dropdown menu={{
            items: items(row),
          }}
            trigger={['click']}
          >
            <button className='btn btn-light'><MdOutlineMoreVert /></button>


          </Dropdown>

        </div>


      )
    },

  ];


  useEffect(() => {

    var set_perpage = 0;
    if (location.search) {
      const parsed = queryString.parse(location.search);
      if (parsed.perpage) {
        if ([20, 50, 100, 500].includes(parseInt(parsed.perpage))) {
          setInitLoad(true)
        } else {
          setStorage('perpage', 20)
          set_perpage = 1;
        }

      } else {
        set_perpage = 1;
      }

    } else {
      set_perpage = 1;
    }

    if (set_perpage == 1) {


      navigate(updateFilterUrl(window.location.search, 'jobs', 1), { replace: true })
    }

  }, [location.search]);

  const { data, error, isError, isLoading, isFetching } = useQuery(["jobs", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
    enabled: initialLoad
  });


  const clearSelection = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
  }
  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        search: filter.search,
        date: filter.date,
        status: filter.status,
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {
    if (data) {
      const parsed = queryString.parse(location.search);
      var setpage = 1;
      if (parsed.page) {
        setpage = parseInt(parsed.page);
      }
      if (parsed.page && parseInt(parsed.page) > 1 && data.items.length == 0) {
        let currentUrlParams = new URLSearchParams(window.location.search);

        setpage = Math.ceil(data.total / parseInt(tableParams.pagination.pageSize));
        setPage(setpage)

        currentUrlParams.set('page', setpage);

        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });

        navigate('/jobs?' + currentUrlParams.toString(), { replace: true })
      } else {
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });
      }
    }

  }, [data]);




  const handleTableChange = (pagination, filters, sorter) => {
    var direction = ''

    if (sorter.order == 'ascend') {
      direction = 'asc';
    } else if (sorter.order == 'descend') {
      direction = 'desc';
    }
    var pg = pagination.current
    setPage(pg)
    let currentUrlParams = new URLSearchParams(window.location.search);

    if (sorter.order) {
      currentUrlParams.set('sort_by', sorter.field);
      currentUrlParams.set('sort', direction);
    } else {
      currentUrlParams.delete('sort_by');
      currentUrlParams.delete('sort');
    }

    currentUrlParams.set('page', pg);
    var perpage = pagination.pageSize
    currentUrlParams.set('perpage', perpage);
    setStorage('perpage', perpage)
    if (location.search) {
      navigate('/jobs?' + currentUrlParams.toString(), { replace: true })
    } else {
      navigate('/jobs?' + currentUrlParams.toString())
    }

    setTableParams({
      pagination,
      filters,
      ...sorter,
    });


  };
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedRows)
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };

  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Jobs
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Jobs" >



            <UiButton className={`btn me-2  ${showFilter ? 'btn-info' : 'btn-secondary'}`} onClick={() => setShowFilter(!showFilter)} title="Filter" ></UiButton>
            <UiButton className="btn btn-primary" onClick={() => addAccount('new')} title="Add" icon="add"></UiButton>



          </PageHeader>

          <div className="position-relative bg-white rounded mb-4">
            <div className={`${showFilter ? 'd-block' : 'd-none'}`}>
              <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
                <div className="p-3 ">

                  <div className="row">

                    <div className="col">
                      <UiInput
                        label="Search"
                        type="text"

                        name="search"

                        {...register("search")}
                      />
                    </div>

                    <div className="col-md-3">

                      <label className="form-label">Date</label>
                      <Controller
                        name="date"
                        control={control}
                        defaultValue="All Time"
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                          formState,
                        }) => (
                          <UiDateRange

                            onUpdate={onChange}
                            value={value}
                            ref={ref}
                            name={name}

                          />
                        )}
                      />
                    </div>
                    <div className="col-md-3">

                      <UiSelect
                        label='Status'
                        name="status"
                        options={["Pending", "Completed", "Hold", "Delivered", "ServiceCenter"]}
                        {...register(`status`)}
                      />
                    </div>




                    <div className="col-md-2" style={{ paddingTop: '28px', minWidth: '200px' }}>
                      <div className="d-flex justify-content-end">

                        <UiButton type="" className="ms-2 btn-light" title={<IoMdClose />} onClick={() => clearFilter()} />
                        <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                      </div>

                    </div>
                  </div>



                </div>
              </form>
            </div>
     




            <Table
              locale={{
                emptyText: (<TableZero title="Jobs" />)
              }}

              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={data.items}
              pagination={{ ...tableParams.pagination, showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` }}
              loading={{ spinning: (tableDisable || isFetching) }}
              //rowSelection={rowSelection}
              onChange={handleTableChange}
              scroll={{
                x: 1060,

              }}
            />
          </div>

        </div>
      </div>
    </>
  );
}
